export default __webpack_public_path__ + "static/media/chevronLeft.bffa68d1.svg";